import type { Card } from '../../types';

export const VENOM: Card = {
  id: 'venom',
  name: 'Venom',
  type: 'support',
  rarity: 'common',
  size: { w: 1, h: 2 },
  cost: [{ kind: 'min', value: 2 }],
  effects: [
    {
      kind: 'applyStatus',
      application: { status: 'poison', magnitude: 2, duration: 2, target: 'opponent' },
    },
  ],
};
